import React, { FC } from 'react';

import styled from 'styled-components';

import { Box, BoxProps } from '@mui/material';

import { themes } from '../../../../consts/experiences';

export const CardWrapper = styled((props: BoxProps) => <Box component="div" {...props} />)`
  width: 100%;
  max-width: 325px;
  margin: 20px 10px;
  border-radius: 10px;
  background-color: ${themes?.white};
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
` as FC<BoxProps>;
